<template>
  <div>
    <section>
      <b-container :class="loading ? 'loading-wrapper' : ''">
        <b-row>
          <b-col cols="12" lg="9">
            <FilterLocation />
            <FilterPoints
              :min="directory.points.min"
              :max="directory.points.max"
              @change="setDirectoryFilterPoints($event)"
              />
          </b-col>
          <b-col cols="12" lg="3">
            <div class="total-redemption mb-5">
              <span class="num-redemption">{{ directoryTotalResults }}</span>
              <span class="text">{{translate('hdFreeStays', directoryTotalResults)}}</span>
              <transition name="show">
                <clear-filters
                  :canClear="isSomeFilterSelected"
                  v-on:clear="onClear"/>
              </transition>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="entity-hotel-directory-list background-grey mb-5 w-100">
      <b-container>
          <b-row class="py-5">
            <HotelCardPlaceHolder v-if="initLoading" />
            <NoResults v-if="isDirectoryEmpty()"/>
            <HotelCard v-else v-for="(hotel, index) in directoryHotels" :key="index" :hotel="hotel"
            :tripAdvisorRating="tripAdvisorRatingForHotel(hotel.code)" />
          </b-row>
          <button v-if="showLoadMore()" class="btn btn-link js-show-more w-100 mb-5" @click="loadMoreDirectoryHotels()">
            <span class="text text-caps font-bold">{{translate('hdLoadMore')}} </span>
            <i class="icon-arrow-down xxs"></i>
          </button>
      </b-container>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import HotelCard from '@/components/directory/HotelCard'
import FilterLocation from '@/components/directory/FilterLocation'
import FilterPoints from '@/components/directory/FilterPoints'
import ClearFilters from '@/components/filters/ClearFilters'
import HotelCardPlaceHolder from '@/components/HotelCardPlaceHolder'
import NoResults from '@/components/NoResults'
import { FilterPaginationDirectory } from '@/infrastructure/Configuration'

export default {
  name: 'Directory',
  components: {
    HotelCard,
    FilterLocation,
    FilterPoints,
    ClearFilters,
    HotelCardPlaceHolder,
    NoResults
  },
  computed: {
    ...mapState(['tripAdvisorRating', 'directory', 'loading']),
    ...mapGetters(['directoryHotels', 'tripAdvisorRatingForHotel', 'directoryTotalResults', 'isSomeFilterSelected']),
    initLoading: function () {
      return !this.directoryHotels || this.directoryHotels.length === 0
    }
  },
  methods: {
    ...mapActions(['setDirectoryFilterPoints', 'loadMoreDirectoryHotels']),
    isDirectoryEmpty () {
      return (!this.directoryHotels || this.directoryHotels.length === 0) && !this.loading
    },
    showLoadMore () {
      return !this.isDirectoryEmpty || this.directoryTotalResults > FilterPaginationDirectory.LIMIT || (this.directoryHotels && this.directoryHotels.length < this.directoryTotalResults)
    },
    onClear () {
      this.$store.dispatch('resetFilters')
      this.$store.dispatch('resetDirectoryPagination')
      this.$store.dispatch('resetDirectoryHotels')
      this.$store.dispatch('getDirectoryHotels')
    }
  },
  async created () {
    try {
      await this.$store.dispatch('getDirectoryHotels')
    } finally {
      await this.$store.dispatch('sendAnalyticsView')
    }
  }
}
</script>
